import React from "react";
import {
  NavLink,
  useParams,
} from "react-router-dom";
import titleize from "underscore.string/titleize";
import {
  Layouts,
  Loaders,
  PitchEditor,
} from "./../components";
import {StatusBar} from "./../components/offer";
import { 
  useOffer,
} from "./../queries/offer";

function OfferEdit() {

  let { offer_id } = useParams();
  const {data:offer, isLoading } = useOffer({offer_id});

  if(isLoading) 
    return <Loaders.ListPageLoader />

  return (
    <div className="bg-white mvh-100">
      <Layouts.PageHeader left={titleize(offer.name)} right={ <StatusBar offer={offer} /> } />
      <div className="overview-content">
        <div className="nav-tabs-container">
          <ul className="nav nav-tabs px-3" role="tablist">
            <li className="nav-item">
              <NavLink to="pitch-editor" className="nav-link active" data-bs-toggle="tab" data-bs-target="#pitch-editor" role="tab">Pitch</NavLink>
            </li>
          </ul>
        </div>
        <div className="tab-content px-3 pt-3 pb-5">
          <div className="tab-pane fade show active" id="pitch-editor" role="tabpanel">
            <PitchEditor
              pitchableType="offer"
              pitchableId={offer_id}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default OfferEdit;